import { useAuth } from '../../contexts/AuthContext';
import { updateUserMarketingDetails } from '../../clients/userClient';

function PersonaModal({ isOpen, onRequestClose, email, setUserDetails }) {
    const { authToken } = useAuth();
    if (!isOpen) {
        return null;
    }

    function submitMarketingDetails() {
        const professionalRole = document.getElementById('professional-role').value;
        const referralSource = document.getElementById('referral-source').value;

        updateUserMarketingDetails(email, authToken, professionalRole, referralSource)
            .then((res) => {
                setUserDetails(res.user)
                onRequestClose();
            });
    }

    return (
        <>
            <div className="fixed inset-0 bg-black bg-opacity-50" onClick={onRequestClose} />
            <dialog id="my_modal_3" className="modal" open>
                <div className="modal-box rounded-none bg-white">
                    {/* <form method="dialog">
                        <button className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2" onClick={onRequestClose}>✕</button>
                    </form> */}

                    <form>
                        <div className="space-y-12 text-left">
                            <div className="border-b border-gray-900/10 pb-12">
                                <h2 className="text-base font-semibold leading-7 text-gray-900">Just One More Thing</h2>
                                <p className="mt-1 text-sm leading-6 text-gray-600">(we promise)</p>

                                <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                                    <div className="col-span-full">
                                        <label htmlFor="referral-source" className="block text-sm font-medium leading-6 text-gray-900">
                                            How did you hear about us?
                                        </label>
                                        <div className="mt-2">
                                            <input
                                                type="text"
                                                name="referral-source"
                                                id="referral-source"
                                                placeholder="Reddit"
                                                autoComplete="off"
                                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-span-full">
                                        <label htmlFor="professional-role" className="block text-sm font-medium leading-6 text-gray-900">
                                            What is your professional role?
                                        </label>
                                        <div className="mt-2">
                                            <input
                                                type="text"
                                                name="professional-role"
                                                id="professional-role"
                                                placeholder="Business Development Rep"
                                                autoComplete="role"
                                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>

                    <div className="w-full flex justify-center items-center space-x-4 pt-3">
                        <button
                            type="button"
                            onClick={submitMarketingDetails}
                            className="flex items-center mb-3 rounded-full bg-custom-orange px-4 py-2.5 text-md font-semibold text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                        >
                            Submit
                        </button>
                    </div>
                </div>
            </dialog>
        </>
    );
}

export default PersonaModal;